import styled from "styled-components";

export const LogoImage = styled.img``;
